import { colors } from "ui-components";

/* Override radio styles from Material UI */
const radioStyles = {
  group: {
    display: "flex",
    alignItems: "center",
    margin: "0"
  },
  button: { width: "auto" },
  icon: {
    marginRight: "2px",
    fill: `${colors.darkBlue}`
    //width: "16px",
    //height: "16px"
  },
  label: {
    margin: 0,
    color: "#9B9B9B",
    fontWeight: "normal"
    //fontSize: "14px"
    //lineHeight: "16px"
  }
};

export { radioStyles };



// WEBPACK FOOTER //
// ./src/workerhome/components/Content/RiskSelector/styled.js